export const profileSet = (state) => {
  return {
    type: "PROFILE_SET",
    payload: state,
  };
};

export const profileUpdate = (state) => {
  return {
    type: "PROFILE_UPDATE",
    payload: state,
  };
};

export const profileClear = () => {
  return {
    type: "PROFILE_CLEAR",
  };
};
